import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import styles from './footer.module.css';

import constants from "../../../constants.js";

const Footer = () => {
  const navigate = useNavigate();

  const navigateTo = (e) => {
    switch (e.currentTarget.id) {
      case "facebook":
        window.open(constants.externalLinks.facebook, '_blank', 'noopener,noreferrer');
      case "instagram":
        window.open(constants.externalLinks.instagram, '_blank', 'noopener,noreferrer');
      case "privacy": 
        navigate('/privacy', { replace: true });
      default:
        return
    }
  }

  return (
    <div className={styles.Footer}>
        <div className={styles.Main}>
          <img src="/icons/cpl-logo.svg" className={styles.Logo}/>
          <div className={styles.FlexColumn}>
            <Link to="/about-us" style={{textDecoration:'none'}}><div className={styles.Text}>{constants.aboutUs}</div></Link>
            <Link to="/contact-us" style={{textDecoration:'none'}}><div className={styles.Text}>{constants.contactUs}</div></Link>
            <Link to="/registration" style={{textDecoration:'none'}}><div className={styles.Text}>{constants.labels.registration}</div></Link>
            <Link to="/leagues" style={{textDecoration:'none'}}><div className={styles.Text}>{constants.leagues}</div></Link>
          </div>
          <div className={styles.FlexColumn}>
            <div style={{fontWeight:'600', color:`${constants.colors.cplWhite}`}}>{constants.contactUs}</div>
            <div className={styles.Text} onClick={(e)=>navigateTo(e)}>
              <img src="/icons/email.svg" style={{marginRight:'5px'}}/>
              <span>crossclubleague@gmail.com</span>
            </div>
          </div>
        </div>
        <hr className={styles.Spacer}/>
        <div className={styles.Secondary}>
          <div className={styles.IconGroup}>
            <img id="facebook" className={styles.Icon} src="/icons/fb-yellow.svg" onClick={(e)=>navigateTo(e)}/>
            <img id="instagram" className={styles.Icon} src="/icons/insta-yellow.svg" onClick={(e)=>navigateTo(e)}/>
          </div>
          <div className={styles.Privacy} style={{}}>© 2025 Cross Club Pickleball League. All Rights Reserved.</div>
          <div style={{display:'flex', flexDirection:'row'}}>
            <div id="privacy" className={styles.Text} onClick={(e)=>navigateTo(e)}>Privacy Policy</div>
          </div>
        </div>
    </div>
  )
}

export default Footer;
